import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Address } from '@models/address';
import { BusinessClient, ClientType, PersonClient } from '@models/clients';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterClients } from '@state/global/matter_clients';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { SelectedMatter } from '@state/matter/matter.selectors';

@UntilDestroy()
@Component({
	selector: 'app-sale-location',
	templateUrl: './location.component.html',
	styleUrls: ['./location.component.scss'],
	standalone: false,
})
export class SaleLocationComponent implements OnInit {
	apiLoaded: Observable<boolean>;
	public locationStreetViewUrl;
	public address: Address;
	public clientTypes = ClientType;

	@Select(SelectedMatter.address) selectedAddress$: Observable<Address>;
	@ViewSelectSnapshot(MatterClients.get) clients: (
		| PersonClient
		| BusinessClient
	)[];
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		public httpClient: HttpClient,
		public routeService: NavigationService,
	) {}

	ngOnInit(): void {
		this.selectedAddress$
			.pipe(untilDestroyed(this))
			.subscribe((_add: Address) => {
				if (_add) {
					this.address = _add;
					this.locationStreetViewUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${_add.street}%2C${_add.city}%2C${_add.province}%2C${_add.country}%2C${_add.postcode}&markers=color:red%7C${_add?._geoloc.lat},${_add?._geoloc.lng}&size=600x400&zoom=17&key=${environment.firebase.apiKey}`;
				}
			});
	}
}
